import { nanoid } from 'nanoid';
import React from 'react';

import useArrayHalves from '@/hooks/use-array-halves';
import { useGlobalContext } from '@/hooks/use-global-context';

import {
  BackgroundColor,
  backgroundColorToColorNameMap,
} from '@/enums/background-color';
import Carousel, { CarouselVariant } from '@/features/carousel';
import {
  InfiniteCarouselDirection,
  InfiniteCarouselProps,
} from '@/features/carousel/components/infinite-carousel';
import { JobBlocksLocationsProps } from '@/features/job-blocks';
import CardLocation from '@/features/job-blocks/components/card-location';
import { PopularLocationsResponse } from '@/services/popular-locations.service';
import { transformJobDisciplineTitle } from '@/services/transformers/public-jobs-transformer';

const availableBackgrounds = [
  BackgroundColor.PRIMARY_LIGHT,
  BackgroundColor.LIGHT_BLUE,
  BackgroundColor.LIGHT_PURPLE,
];

export default function JobBlocksLocations(_: JobBlocksLocationsProps) {
  const { pageStaticData } = useGlobalContext();

  const groupPopularLocations = useArrayHalves(
    pageStaticData?.popularLocations || []
  );

  const popularDestinationToCarouselItem = (
    props: PopularLocationsResponse[number],
    index: number
  ) => ({
    id: nanoid(),
    component: (
      <CardLocation
        weeklyPay={props.weekly_pay}
        location={{
          state: props.state,
          city: props.city,
        }}
        discipline={transformJobDisciplineTitle(props.discipline)}
        disciplineApiId={props.discipline}
        locationApiId={props.location_api_id}
        className={
          backgroundColorToColorNameMap[
            availableBackgrounds[index % availableBackgrounds.length]
          ]
        }
      />
    ),
  });

  const commonProps: Omit<InfiniteCarouselProps, 'direction' | 'items'> = {
    variant: CarouselVariant.INFINITE,
    pauseOnHover: true,
    heightClassName: 'h-56',
  };

  return (
    <div className='flex flex-col gap-4'>
      <Carousel
        {...commonProps}
        direction={InfiniteCarouselDirection.LEFT_TO_RIGHT}
        speed='slow'
        items={groupPopularLocations[0].map(popularDestinationToCarouselItem)}
      />
      <Carousel
        {...commonProps}
        direction={InfiniteCarouselDirection.RIGHT_TO_LEFT}
        speed='slow'
        items={groupPopularLocations[1].map(popularDestinationToCarouselItem)}
      />
    </div>
  );
}
